import { useMutation, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'

interface UpdateTaskVariables {
  taskPK: string
  taskSK: string
  taskData?: Record<string, any>
  [key: string]: any
}

export const useUpdateTask = () => {
  const queryClient = useQueryClient()

  const mutation = useMutation({
    mutationFn: async ({ taskPK, taskSK, ...updatedData }: UpdateTaskVariables) => {
      // ✅ Spread updatedData
      console.log('Updating task with:', { taskPK, taskSK, updatedData })

      const encodedPK = encodeURIComponent(taskPK)
      const encodedSK = encodeURIComponent(taskSK)

      const url = `${baseUrl}/aws/tasks/${encodedPK}/${encodedSK}`
      const response = await axios.put(url, updatedData) // ✅ Send updates directly
      return response.data
    },

    onMutate: async ({ taskPK, taskSK, taskData }: UpdateTaskVariables) => {
      const taskKey = [`task`, taskPK, taskSK]

      await queryClient.cancelQueries({ queryKey: taskKey })
      const previousTask = queryClient.getQueryData(taskKey)

      queryClient.setQueryData(taskKey, (old: any) => ({
        ...old,
        ...taskData,
      }))

      return { previousTask }
    },

    onError: (err, { taskPK, taskSK }: UpdateTaskVariables, context: any) => {
      const taskKey = [`task`, taskPK, taskSK]
      queryClient.setQueryData(taskKey, context?.previousTask)
    },

    onSuccess: (_, { taskPK, taskSK }: UpdateTaskVariables) => {
      console.log('taskPK', taskPK, 'taskSK', taskSK)
      // queryClient.invalidateQueries({ queryKey: ['task', taskPK, taskSK] })
      // queryClient.invalidateQueries({ queryKey: ['teamTasks', {}] })
    },
  })

  return mutation
}
